import { ReadOnlyStepProps } from "../../useStepEditor";
import { useAutomationStep } from "../../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../../components/atoms";
import { ReadOnlyMessage } from "../../../components/ReadOnlyMessage";
import { isEmpty } from "lodash";
import { LegacyEmailViewer } from "./../LegacyEmailViewer";
import { EmailMembers } from "./../EmailMembers";
import { AttachmentViewer } from "modules/workflows/blocks/Attachments/AttachmentViewer";
import { FormShareViewer } from "../../../components/FormShareViewer";
import { StepReminderViewer } from "../../../components/StepReminderViewer";

export const EmailFormV3StepViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step) return <div />;

  const { resolved } = step.resolvedData as any;

  if (!resolved) return <LegacyEmailViewer step={step} />;

  const executionData = step.executionData as any;
  const formShares = executionData?.formShares || [];

  const stepData = step.stepData as any;
  const reminderConfig = stepData?.reminders?.[0];

  return (
    <>
      {!isEmpty(formShares) && (
        <Block blended compact>
          <FormShareViewer formShares={formShares} />
        </Block>
      )}
      <Block blended compact>
        <EmailMembers {...resolved} />
      </Block>
      {reminderConfig && (
        <Block blended compact>
          <StepReminderViewer stepId={stepId} reminderConfig={reminderConfig} />
        </Block>
      )}
      <Block blended compact>
        <ReadOnlyMessage
          subject={resolved.subject}
          message={resolved.message}
          opens={stepData?.trackEmail ? executionData?.opens : undefined}
        />
      </Block>
      {!isEmpty(resolved.attachments) && (
        <Block blended compact>
          <AttachmentViewer attachments={resolved.attachments} />
        </Block>
      )}
    </>
  );
};
